// Lib
import React from 'react';
import classNames from 'classnames';

// Components
import Toast from '../../../../../structural/toast/Toast';
import ProgressBar from '../../../../file/uploader/ProgressBar';
import { BACKGROUND_REMOVAL_PROGRESS_TYPE } from './imageModalBackgroundRemovalProgressTypes';
import {
    IMAGE_MODAL_BACKGROUND_REMOVAL_TOAST_MESSAGE,
    type ImageModalBackgroundRemovalToastState,
} from './imageModalBackgroundRemovalToastTypes';

// Styles
import './ImageModalBackgroundRemovalToast.scss';

/**
 * Shows background-removal progress inside the image modal toast layer.
 */
const ImageModalBackgroundRemovalToast: React.FC<{
    toast: ImageModalBackgroundRemovalToastState | null;
}> = ({ toast }) => {
    if (!toast) return null;

    const { progress } = toast;
    const isDeterminate = progress?.type === BACKGROUND_REMOVAL_PROGRESS_TYPE.DETERMINATE;
    const isUploadingImage = toast.message === IMAGE_MODAL_BACKGROUND_REMOVAL_TOAST_MESSAGE.UPLOADING_IMAGE;
    const showBarbershopProgress = !isDeterminate;
    const percentageComplete = isDeterminate ? progress.percentageComplete : 100;
    const message = isUploadingImage ? 'Uploading image' : 'Removing background';

    return (
        <Toast
            className={classNames('ImageModalBackgroundRemovalToast', {
                uploading: isUploadingImage,
                removing: !isUploadingImage,
            })}
            groupId="ImageModalV2"
        >
            <ProgressBar
                percentageComplete={percentageComplete}
                barbershop={showBarbershopProgress}
                animate={showBarbershopProgress}
            />
            <span className="message">{message}</span>
        </Toast>
    );
};

export default ImageModalBackgroundRemovalToast;
